import { getCurrentLocaleCode } from "@mongez/localization";
import { InputRule } from "@mongez/react-form";
import type { AppDirection } from "../types";

export const isRTL = () => getCurrentLocaleCode() === "ar";
export const isLTR = () => getCurrentLocaleCode() === "en";
export const currentDirection = (): AppDirection =>
  (isRTL() ? "rtl" : "ltr") as AppDirection;

// Accept only arabic letters and white spaces
export const arabicNamePattern = /^[\u0600-\u06FF\s]+$/;

export const minWordsRule: InputRule = {
  requiresValue: true,
  validate({ value, minWords, errors }) {
    if (!minWords) return;

    const words = value.trim().split(" ");

    if (words.length < minWords) {
      return errors.minWords;
    }
  },
};
